var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, SnackbarContent, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import clsx from 'clsx';
import { useContentStyles } from './style';
var variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: WarningIcon,
    info: InfoIcon,
};
var Notification = function (props) {
    var classes = useContentStyles();
    var className = props.className, message = props.message, onClose = props.onClose, variant = props.variant, other = __rest(props, ["className", "message", "onClose", "variant"]);
    var Icon = variantIcon[variant];
    return (_jsx(SnackbarContent, __assign({ className: clsx(className, classes.content), "aria-describedby": "client-snackbar", message: _jsxs(Box, __assign({ id: "client-snackbar", display: "flex", alignItems: "center" }, { children: [_jsx(Icon, { className: classes.iconVariant }, void 0),
                _jsx(Typography, __assign({ className: classes.message, component: "span" }, { children: message }), void 0)] }), void 0), action: [
            _jsx(IconButton, __assign({ "aria-label": "close", onClick: onClose }, { children: _jsx(CloseIcon, { className: classes.iconClose }, void 0) }), "close"),
        ] }, other), void 0));
};
export default Notification;
